// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__QHlJg","title":"InfoRow_title__335T7"};